import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <path d="M12 7v10M17 12H7" />
    </g>
  </svg>
);
